import { useEffect } from 'react';

/**
 * Puts the account theme tokens on <body> while a signed-in layout is mounted,
 * so dialogs, menus and selects that portal outside the layout share its theme.
 * Pass false for layouts that keep the site theme (auth, client presentations).
 */
export const useAccountTheme = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    document.body.classList.add('account-theme');
    return () => document.body.classList.remove('account-theme');
  }, [enabled]);
};
